<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-20">
      <!-- begin col-8 -->
      <div class="col-sm-12">
        <!-- begin widget-chart -->
        <div
          class="widget widget-rounded m-b-30"
          v-bind:class="{ 'inverse-mode': inverseMode }"
        >
          <div class="card-body" style="padding: 5px 10px">
            <div class="ts-flex ts-justify-between">
              <div
                class="ts-flex ts-justify-content-start"
                :class="{ 'ts-text-gray-700': !inverseMode }"
              >
                <strong>
                  TOP 10 SLOW PRODUCT SOLD & PROMOTION STATISTIC
                </strong>
                <span class="ml-2"
                  ><i
                    class="fa fa-info-circle"
                    title="Top products with units sold"
                    v-b-popover.hover="
                      'Products with the most individual units sold. Includes orders from all sales channels.'
                    "
                  ></i
                ></span>
              </div>
              <div class="ts-flex ts-justify-content-end">
                <select
                  v-model="branch_id"
                  @change="fetchData"
                  style="width: 150px"
                  class="filter mr-2"
                  :class="{ 'filter-dark': inverseMode }"
                >
                  <option value>--Select Branch--</option>
                  <option
                    v-for="(branch, key) in branches"
                    :value="branch.branch_id"
                    :key="key"
                  >
                    {{ branch.branch_name_en }}
                  </option>
                </select>
                <select
                  class="filter mr-2"
                  :class="{ 'filter-dark': inverseMode }"
                  v-model="selectedOpt"
                  @change="fetchData"
                >
                  <option
                    v-for="(filter, filterKey) in optionFilters"
                    :value="filterKey"
                    :key="filterKey"
                  >
                    {{ filter }}
                  </option>
                </select>
                <a-range-picker
                  style="width: 300px"
                  v-model="rangeDate"
                  :ranges="{
                    Today: [moment(), moment()],
                    'This Month': [
                      moment().startOf('month'),
                      moment().endOf('month')
                    ]
                  }"
                  format="DD-MM-YYYY"
                />
              </div>
            </div>
          </div>
          <!-- begin vertical-box -->
          <ts-loading-banner :loading="loading">
            <div class="vertical-box with-grid with-border-top">
              <!-- begin vertical-box-column -->
              <div class="vertical-box-column" style="width: 40%">
                <p class="p-2">
                  Polar area charts shows the top ten sale items based on the
                  selected categories.
                </p>
                <vn-hbar
                  :model="multiBarHorizontalChart.data"
                  y-format=".0f"
                  :showControls="areaChart.showControls"
                >
                </vn-hbar>
              </div>
              <!-- end vertical-box-column -->
              <!-- begin vertical-box-column -->
              <div class="vertical-box-column widget-chart-content">
                <div class="nv-stacked-area-chart height-full">
                  <p class="p-2">
                    Stacked area charts shows the quantities of the total sale
                    items based on the selected period of dates by branch or
                    company.
                  </p>
                  <bar-chart
                    :data="{
                      labels: labels,
                      datasets: datasets
                    }"
                    :options="options"
                    class="height-sm"
                  ></bar-chart>
                </div>
              </div>
              <!-- end vertical-box-column -->
            </div>
          </ts-loading-banner>
          <!-- end vertical-box -->
        </div>
        <!-- end widget-chart -->
      </div>
      <!-- end col-8 -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import BarChart from '@/components/vue-chartjs/BarChart'
import moment from 'moment'
import { map } from 'lodash'
import { mapActions } from 'vuex'
export default {
  components: {
    BarChart
  },
  props: ['inverseMode'],
  data () {
    return {
      optionFilters: {
        invoice_date: 'Day',
        sale_by_week: 'Week',
        sale_by_month: 'Month',
        sale_by_year: 'Year'
      },
      loading: false,
      selectedOpt: 'invoice_date',
      branch_id: '',
      rangeDate: [
        moment()
          .add(-1, 'Month')
          .startOf('month'),
        moment().endOf('month')
      ],
      groups: [],
      resources: [],
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      borderColor: ['#727cb6', '#348fe2', '#ffc107', '#b6c2c9'],
      backgroundColor: [
        'rgba(114, 124, 182, 0.5)',
        'rgba(52, 143, 226, 0.5)',
        'rgba(255, 193, 7, 0.5)',
        'rgba(182, 194, 201, 0.5)'
      ],
      // polar Area Chart
      top10SlowProductSold: [],
      areaChart: {
        rightAlignYAxis: false,
        showControls: false,
        clipEdge: false
      }
    }
  },
  computed: {
    branches () {
      return this.$store.state.dashboard.widget.branches
    },
    // bar chart
    labels () {
      return map(this.resources, item => {
        return item.date
      })
    },
    datasets () {
      return this.groups.map((g, index) => {
        return {
          label: g,
          borderColor: this.borderColor[index],
          backgroundColor: this.backgroundColor[index],
          borderWidth: 2,
          fillOpacity: 0.3,
          data: map(this.resources, r => {
            return r[g].toFixed(2)
          })
        }
      })
    },
    multiBarHorizontalChart () {
      return {
        data: [
          {
            key: 'Quantity',
            color: '#f59c1a',
            values: map(this.top10SlowProductSold, (item, key) => {
              return {
                label: key,
                value: item.quantity
              }
            })
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions('dashboard/widget', ['getBranch']),
    moment,
    fetchData (attributes = {}) {
      this.top10SlowProductSold = []
      this.loading = true
      this.$store
        .dispatch(
          'dashboard/widget/fetchPromotionStatistic',
          Object.assign(
            {
              branch_id: this.branch_id,
              sale_date: this.selectedOpt,
              date_from: this.rangeDate[0].format('DD-MM-YYYY'),
              date_to: this.rangeDate[1].format('DD-MM-YYYY')
            },
            attributes
          )
        )
        .then(responses => {
          this.groups = responses.groups
          this.resources = responses.collection
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
      this.$store
        .dispatch('dashboard/widget/fetchTop10SlowProductSold', {
          branch_id: this.branch_id,
          sale_date: this.selectedOpt,
          date_from: this.rangeDate[0].format('DD-MM-YYYY'),
          date_to: this.rangeDate[1].format('DD-MM-YYYY')
        })
        .then(responses => {
          this.loading = false
          for (var propName in responses) {
            if (responses.hasOwnProperty(propName)) {
              this.top10SlowProductSold = responses[propName]
            }
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    }
  },

  watch: {
    rangeDate: function () {
      this.fetchData()
    }
  }
}
</script>
<style scoped>
.nvd3-svg {
  width: 100% !important;
}
.filter {
  color: #707478;
  border: 1px solid #d3d8de;
  -webkit-box-shadow: none;
  box-shadow: none;
  height: 35px;
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}
.filter-dark {
  background-color: #242a30;
  color: white;
  border: 1px solid #1a1e22;
}
.widget-header-title,
.widget-header-icon {
  padding: 5px 10px !important;
}
</style>
